import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface StudioState {
  selectedId: string | null;
  search: string;
  searchType: string;
  filter: string;
}

const initialState: StudioState = {
  selectedId: null,
  search: "",
  searchType: "",
  filter: ""
};

const studioSlice = createSlice({
  name: "studio",
  initialState: initialState,

  reducers: {
    setSelectedId(state, action: PayloadAction<string | null>) {
      state.selectedId = action.payload;
    },
    setSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
    },
    setSearchType(state, action: PayloadAction<string>) {
      state.searchType = action.payload;
    },
    setFilter(state, action: PayloadAction<string>) {
      state.filter = action.payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const { setSelectedId, setSearch, setSearchType, setFilter } = studioSlice.actions;

export default studioSlice.reducer;
